import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Item as dxListItem, ItemClickEvent } from 'devextreme/ui/list';
import { ValueChangedEvent as NumberBoxValueChangeEvent } from 'devextreme/ui/number_box';

import { NextPimField } from 'app/Model/Catalog/NextPimField';
import { fieldNames } from 'app/Model/FieldNames';
import { TemplateService } from 'app/Services/template.service';
import { TemplateItem } from 'app/Model/Catalog/TemplateItem';
import { comparePimFields, fillLastKey, isNextPimField, parsePimField } from 'app/Services/templateItemHelpers';
import { HazmatClass } from 'app/Model/Catalog/HazmatClass';
import { WarrantyClass } from 'app/Model/Catalog/WarrantyClass';
import { TemplateItemTemplate } from '../../Model/Catalog/TemplateItemTemplate';
import { DxDropDownBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'np-advanced-template-legal',
  templateUrl: './advanced-template-legal.component.html',
})
export class AdvancedTemplateLegalComponent implements OnInit, OnDestroy {
  @ViewChild('legalFieldListDropDown', { static: false }) legalFieldListDropDown!: DxDropDownBoxComponent;
  @ViewChild('legalWarrentyClassDropDown', { static: false }) legalWarrentyClassDropDown!: DxDropDownBoxComponent;
  @ViewChild('legalHazmatClassDropDown', { static: false }) legalHazmatClassDropDown!: DxDropDownBoxComponent;
  private unsubscribe$ = new Subject<void>();

  @Input() templateItem: TemplateItem;
  @Input() customerId: string;
  @Input() warrantyClasses: WarrantyClass[] = [];
  @Input() hazmatClasses: HazmatClass[] = [];
  @Input() fieldList: TemplateItemTemplate[] = [];
  @Output() onUpdate = new EventEmitter<void>();

  get pimField() {
    if (!this.templateItem.pimFields || this.templateItem.pimFields.length === 0) {
      this.templateItem.pimFields = [new NextPimField()];
    }
    return this.templateItem.pimFields[0];
  }

  get isRadioGroupItem() {
    return this.pimField.field !== fieldNames.hazmatClassNew && this.pimField.field !== fieldNames.warrantyClassNew;
  }

  get isHazmatClass() {
    return this.pimField.field === fieldNames.hazmatClassNew;
  }

  get isWarrantyClass() {
    return this.pimField.field === fieldNames.warrantyClassNew;
  }

  constructor(private templateService: TemplateService) {}

  ngOnInit() {
    this.pimField.systemKey = '-1';
    this.pimField.elementKey = '-1';
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getFieldDisplayExpr(item: TemplateItemTemplate) {
    return item?.text === item?.field ? item?.field ?? '' : `${item.text} (${item.field})`;
  }

  onFieldItemClick(event: ItemClickEvent<TemplateItemTemplate>, source: string) {
    this.pimField.field = event.itemData.field;
    switch (source) {
      case 'fieldList':
        this.legalFieldListDropDown.instance.close();
        break;
      case 'warrantyClasses':
        this.legalWarrentyClassDropDown.instance.close();
        break;
      case 'hazmatClasses':
        this.legalHazmatClassDropDown.instance.close();
        break;
    }
    this.update();
  }

  onOrderChanged(event: NumberBoxValueChangeEvent) {
    this.update();
  }

  private update() {
    const { field, systemKey, elementKey } = this.pimField;
    const parsedKey = parsePimField(this.templateItem.key);
    if (parsedKey !== null && (comparePimFields(parsedKey, this.pimField) || !isNextPimField(parsedKey.field))) {
      this.onUpdate.emit();
      return;
    }
    this.templateService.getHeadline(field, elementKey, systemKey, this.customerId).subscribe((headline) => {
      fillLastKey(this.templateItem, headline.value);
      this.onUpdate.emit();
    });
  }
}
